import React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from './Navbar';
import Home from './Home';
import Challenges from './Challenges';
// import About from './About';
import Products from './Products';
// import Services from './Services';
// import Team from './Team';
import Contact from './Contact';
import About from "./About";
import Team from "./Team";

function App() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/challenges" element={<Challenges />} />
        <Route path="/products" element={<Products />} />
        <Route path="/contact" element={<Contact />} />
        <Route path ="/about" element={<About />} />
        <Route path="/team" element={<Team />} />
      </Routes>
    </div>
  );
}

export default App;
